import DynamicVerticalCells from "core/dynamic-cells/DynamicVerticalCells";
import Label from "core/label/Label";
import { FormattedMessage } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { ENTITY } from "constants/info-header";
import { tabletSize } from "utils/screenSizes";

const CorporateLife = ({ status, filteredCorporateLife = [] }) => {
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("fr-FR", options);
  };

  const content = filteredCorporateLife.map((event, index) => ({
    date: formatDate(event.date),
    event: event.title || "",
    status: (
      <Label
        id={`event-${event.id || index}`}
        className="medium"
        label={
          event.attended ? (
            <FormattedMessage id="present" defaultMessage="Présent" />
          ) : (
            <FormattedMessage
              id="not_present"
              defaultMessage="Non présent"
            />
          )
        }
        color={event.attended ? "light-lime-green" : "cosmos"}
      />
    ),
  }));

  const corporateLife = {
    header: [
      {
        label: { key: "date", value: "Dates" },
        icon: "calendar",
        width: "22%",
      },
      {
        label: { key: "event", value: "Evénement" },
        icon: "event",
        width: "48%",
      },
      {
        label: { key: "status", value: "Présence à l'événement" },
        icon: "check-list",
        width: "28%",
      },
    ],
    content: content,
  };

  return (
    <>
      <div className="section">
        <Typography
          className="title-3 violet text-uppercase"
          type="h2"
          label={
            <FormattedMessage
              id="corporate_life"
              defaultMessage="Vie d'entreprise"
            />
          }
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "baseline",
            justifyContent: "space-between",
          }}
        >
          <Typography
            className="title-4 light-slate-gray "
            style={{ marginTop: "unset" }}
            type="h2"
            label={
              <FormattedMessage
                id="dash_subtitle"
                defaultMessage="Évènements auxquels la personne s'est inscrit (à partir de décembre 2014) "
              />
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: `${tabletSize ? "column" : "row"}`,
          }}
        >
          <Table
            id="events_1"
            header={corporateLife.header}
            content={corporateLife.content}
          />
        </div>
      </div>
    </>
  );
};

export default CorporateLife;
